import { FormControlLabel, Switch } from "@mui/material";
import { ButtonBoxWrapper, ButtonEl, GraphOperatorFieldWrapper } from "../style/GraphOperator.styled";
import { CustomPeriodTypeButtonGroup } from "../../../../../../../components/buttons/period-type/v1/CustomPeriodTypeButtonGroup";

export default function GraphOperatorFieldView({
    checkedSwitch,
    checkedExcludedDeliveryChargeSwitch,
    searchDimension,
    onChangeSwitch,
    onChangeExcludedDeliveryChargeSwitch,
    onChangeSearchDimension
}) {
    return (
        <GraphOperatorFieldWrapper>
            <div className='toggle-group'>
                <FormControlLabel labelPlacement="start" control={<Switch checked={checkedSwitch} onChange={() => onChangeSwitch()} />} label="주문 데이터 표시" />
                <FormControlLabel labelPlacement="start" control={<Switch checked={checkedExcludedDeliveryChargeSwitch} onChange={() => onChangeExcludedDeliveryChargeSwitch()} />} label="배송비 미포함" />
            </div>
            <ButtonBoxWrapper>
                <CustomPeriodTypeButtonGroup>
                    <CustomPeriodTypeButtonGroup.DateButton
                        checked={searchDimension === 'date'}
                        callback={(result) => onChangeSearchDimension(result)}
                        style={{ marginRight: '3px' }}
                    />
                    <CustomPeriodTypeButtonGroup.WeekButton
                        checked={searchDimension === 'week'}
                        callback={(result) => onChangeSearchDimension(result)}
                        style={{ marginRight: '3px' }}
                    />
                    <CustomPeriodTypeButtonGroup.MonthButton
                        checked={searchDimension === 'month'}
                        callback={(result) => onChangeSearchDimension(result)}
                    />
                </CustomPeriodTypeButtonGroup>
            </ButtonBoxWrapper>
        </GraphOperatorFieldWrapper>
    )
}